export const CDP_INITIATIVE = "wl_cdp";
export const CDP_I18N_NAMESPACE = "app_cldp_common";
